import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import { IProps } from './types';

export const SigininWrapper = ({ form, children, className, isMobile, horizontalView, advertisement }: IProps) => {
  return (
    <div
      className={cn(
        styles.wrapper,
        {
          [styles.wrapper__form]: form && !isMobile,
          [styles.wrapper__form_mobile]: form && isMobile,
          [styles.wrapper_mobile]: (isMobile || horizontalView),
          [styles.wrapper_horizontalView]: horizontalView,
          [styles.wrapper_adv]: horizontalView && advertisement,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
